<template>
  <v-container v-if="visible">
    <v-card>
      <v-card-text>
        <v-container>
          <v-layout d-block>
            <v-flex>
              <v-text-field
                :value="activeAddress.phoneNumber1"
                type="tel"
                :mask="updateMask(activeAddress.phoneNumber1)"
                label="1e telefoonnummer"
                @input="updatePhone1TextEvent"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                :value="activeAddress.phoneNumber2"
                type="tel"
                :mask="updateMask(activeAddress.phoneNumber2)"
                label="2e telefoonnummer"
                @input="updatePhone2TextEvent"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm" color="primary" :disabled="dirty">{{ buttonValue || "Sluiten" }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { phoneUpdateService } from "@/services/address";
import _debounce from 'lodash/debounce'

export const AREA_CODE_NL = /(045|079|078|077|076|075|074|013|014|015|073|072|071|070|058|055|053|050|046|010|044|043|040|038|036|020|035|033|030|026|024|023)/gi;
export const DEBOUNCE_TIMEOUT = 600;

export default {
  name: "PhoneDetails",
  props: ["buttonValue", "visible"],
  data: () => ({
    mask: "(###) ### ## ##",
    phone1: null,
    phone2: null,
    dirty: false,
  }),
  computed: {
    ...mapGetters(["activeAddress"])
  },
  methods: {
    ...mapActions(["updatePhone1", "updatePhone2"]),
    closeForm() {
      this.$parent.closePhoneDetailsForm();
    },
    updatePhone1TextEvent(phoneNumber) {
      this.dirty = true;
      this.updatePhone1(phoneNumber);
      this.updatePhoneDebounced(phoneNumber, this.activeAddress.phoneNumber2);
    },
    updatePhone2TextEvent(phoneNumber) {
      this.dirty = true;
      this.updatePhone2(phoneNumber);
      this.updatePhoneDebounced(this.activeAddress.phoneNumber1, phoneNumber);
    },
    updatePhoneDebounced: _debounce(function (phoneNumber1, phoneNumber2) {
      phoneUpdateService.update(this.activeAddress.uniqueIdAddress, {
        phoneNumber1: phoneNumber1,
        phoneNumber2: phoneNumber2
        // eslint-disable-next-line no-unused-vars
      }).then(e => {
        this.dirty = false;
      });
    }, DEBOUNCE_TIMEOUT),
    updateMask(phone) {
      if (phone) {
        if (phone.startsWith("06", 0)) {
          return "(##) ## ## ## ##";
        } else if (phone.match(AREA_CODE_NL)) {
          return "(###) ### ## ##";
        } else {
          return "(####) ## ## ##";
        }
      } else {
        return "(####) ## ## ##";
      }
    }
  }
};
</script>
